import { useQuery } from "@tanstack/react-query";
import { getSession } from "./api";

const Keys = {
  stripeSession: (sessionId) => ["stripeSession", sessionId],
};

export function useGetStripeSession(sessionId) {
  return useQuery(Keys.stripeSession(sessionId), () => getSession(sessionId), {
    useErrorBoundary: true,
  });
}
